var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnologyIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 19.25H25.25V14.75H14.75V19.25ZM26.75 14V26C26.75 26.1989 26.671 26.3897 26.5303 26.5303C26.3897 26.671 26.1989 26.75 26 26.75H14C13.8011 26.75 13.6103 26.671 13.4697 26.5303C13.329 26.3897 13.25 26.1989 13.25 26V14C13.25 13.8011 13.329 13.6103 13.4697 13.4697C13.6103 13.329 13.8011 13.25 14 13.25H26C26.1989 13.25 26.3897 13.329 26.5303 13.4697C26.671 13.6103 26.75 13.8011 26.75 14ZM25.25 20.75H14.75V25.25H25.25V20.75ZM16.25 22.25H18.5V23.75H16.25V22.25ZM16.25 16.25H18.5V17.75H16.25V16.25Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologyIcon2);
export default __webpack_public_path__ + "static/media/technology_icon2.7cd54ee2756c70a7a3006d7af927154e.svg";
export { ForwardRef as ReactComponent };